import { Autocomplete } from 'components';
import React, { useEffect, useState } from 'react';
import DepartmentServices from 'services/DepartmentServices';

/**
 * AutocompleteField - Themed, reusable autocomplete component with validation, using TextValidator as input.
 *
 * @param {object} props
 * @param {string} props.name - Name of the field (for form handling).
 * @param {string} [props.label] - Label for the field.
 * @param {any} props.value - Value (controlled, can be string, object, or array for multiple).
 * @param {function} props.onChange - Change handler (event, value) => void.
 * @param {boolean} [props.required] - Required field.
 * @param {Array} [props.validators] - Validation rules.
 * @param {Array} [props.errorMessages] - Validation error messages.
 * @returns {JSX.Element}
 */


const Department = ({
    name,
    label,
    value,
    onChange,
    filter,
    required = false,
    validators = [],
    errorMessages = [],
}) => {

    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({...filter, limit: 100, search: null,status:'Active' })



    useEffect(() => {
        const fetchData = async () => {
            try {
                const [data] = await Promise.all([
                    DepartmentServices.getAll({ ...filters}),
                ]);
                console.log('date view',data)

                setData(data?.data?.view?.data || []);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [filters]);

useEffect(() => {
    console.log('Department filters:', filters); // Add this line
    // ...existing code...
}, [filters]);

    return (
        <div>
            <Autocomplete
                name={name}
                label={label}
                value={data.find((item) => item.id === value) || null}
                onChange={(event, newValue) => {
                    if (onChange) onChange(event, newValue);
                }}
                options={data}
                getOptionLabel={option => option.name || option.name || ''}
                textInputOnChange={(e) => {
                    setFilters({ ...filters, search: e.target.value })
                }}
                //isOptionEqualToValue={(option, value) => option?.id === value?.id || option?.value === value?.value}
                required={required}
                validators={validators}
                errorMessages={errorMessages}
            />
        </div>
    );
};

export default Department ;
